import {asString} from './asString';

export function asFloat(o?: unknown): number {
    if( typeof o === 'number' ) {
        return o;
    }

    return parseFloat(asString(o));
}
